@if (fallbackRow(); as fallback) {
  <div
    class="surface-100 border-round-xl p-3 mb-3 flex align-items-center gap-3">
    <i [class]="'fas fa-' + (fallback.published ? 'earth-europe' : 'lock')"></i>
    <span class="flex align-items-center gap-3 flex-1"
      ><i [class]="'w-1rem text-center fas fa-' + fallback.icon"></i>
      {{ fallback.title }}
      @if (fallback.spotlight) {
        <i class="fas fa-star text-yellow-500" pTooltip="im Spotlight"></i>
      }
    </span>
    <a
      pButton
      class="p-button-rounded p-button-xs p-button-primary"
      icon="fas fa-pen"
      [routerLink]="[
        { outlets: { bearbeiten: ['fallback', 'settings'] } },
      ]"></a>
  </div>
}

@if (store.asArray(); as topics) {
  @if (topics.length > 0) {
    <p-table
      #topicTable
      [globalFilterFields]="['title']"
      [loading]="loading"
      [value]="store.sorted()"
      (onRowReorder)="onRowReorder($event)">
      <ng-template pTemplate="caption">
        <app-table-list-caption
          [searchWord]="searchWord"
          (clearTable)="clear(topicTable)"
          [quickLink]="
            activeUserStore.canAccessConfig()
              ? [
                  '/data-backend',
                  {
                    outlets: {
                      overlay: [
                        'konfiguration',
                        { outlets: { panel: 'startseite' } },
                      ],
                    },
                  },
                ]
              : null
          "
          quickLinkLabel="Startseite"
          (search)="
            topicTable.filterGlobal($event, 'contains')
          "></app-table-list-caption>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="w-2rem"></th>
          <th class="w-1rem">Status</th>
          <th>Thema</th>
          <th>Aktionen</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-topic let-rowIndex="rowIndex">
        <tr [pReorderableRow]="rowIndex">
          <td>
            <i class="pi pi-bars cursor-move" pReorderableRowHandle></i>
          </td>
          <td>
            <div class="flex gap-2">
              <i
                class="fas fa-earth-europe"
                [ngClass]="
                  topic.visibleInPublicAtlas
                    ? 'text-primary'
                    : 'text-color-secondary opacity-50'
                "
                [pTooltip]="
                  topic.visibleInPublicAtlas
                    ? 'Im öffentlichen Atlas sichtbar'
                    : 'Im öffentlichen Atlas ausgeblendet'
                "></i>
              <i
                class="fas fa-house-user"
                [ngClass]="
                  topic.visibleInInternalAtlas
                    ? 'text-primary'
                    : 'text-color-secondary opacity-50'
                "
                [pTooltip]="
                  topic.visibleInInternalAtlas
                    ? 'Im internen Atlas sichtbar'
                    : 'Im internen Atlas ausgeblendet'
                "></i>
            </div>
          </td>
          <td>
            <span class="flex align-items-center gap-3"
              ><i [class]="'w-1rem text-center fas fa-' + topic.icon"></i>
              {{ topic.title }}
              @if (topic.spotlight) {
                <i
                  class="fas fa-star text-yellow-500"
                  pTooltip="im Spotlight"></i>
              }
              @if (topicHelper.getTopicStats(topic); as stats) {
                <p-badge
                  [value]="stats.categoryCount + ' Bereiche'"
                  severity="secondary"
                  pTooltip="Zugeordnete Themenbereiche"></p-badge>
                <p-badge
                  [value]="stats.itemCount + ' Ansichten'"
                  severity="secondary"
                  pTooltip="Ansichten & Berichte in diesen Bereichen"></p-badge>
              }
            </span>
          </td>
          <td>
            <app-table-list-actions
              [item]="topic"
              (confirm)="confirm($event, topic, topic.title)">
            </app-table-list-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <app-alert header="Keine Themen gefunden" [canToggle]="false">
      Nutzen Sie Themen, um Ihren Nutzer:innen einen thematischen Einstieg in
      Ihren Atlas zu erm
      <a
        [routerLink]="[
          '/data-backend',
          {
            outlets: {
              overlay: ['themen', { outlets: { bearbeiten: 'neu' } }],
            },
          },
        ]"
        >Formular</a
      >.
    </app-alert>
  }
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-9'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [sub]="editFormOverlaySub"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
